import NewPassword from "./new-password.container";

export default NewPassword